import * as React from 'react';
import { useNavigate } from 'react-router';
import { Grid, Typography } from '@mui/material';
import { MissingPhoto } from 'Interfaces/IGlobalTypeConfig';
import CustomAvatar from '../../../components/ui/customAvatar';
import { t } from 'i18next';

export const SingleOrderCompanyView = (props: any) => {
  const company = props.company;
  console.log('SingleOrderCompanyView - company:', company); // Debug log
  return (
    <Grid
      item
      sx={{
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'row',
        backgroundColor: 'primary.lighter',
      }}
    >
      <Grid
        item
        sx={{
          width: 160,
          borderRadius: 2,
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0,
        }}
      >
        {company?.url ? (
          <img
            src={company?.url || MissingPhoto.COMPANY_URL}
            style={{
              padding: 0,
              width: 160,
              height: 88,
              objectFit: 'scale-down',
            }}
            alt={'logo'}
          />
        ) : (
          <CustomAvatar
            avatarName={company?.name || ''}
            imgWidth={160}
            imgHeight={88}
          />
        )}
      </Grid>
      <Grid item sx={{ flexGrow: 1, backgroundColor: 'primary.dark' }}>
        <Grid container sx={{ pl: 1 }}>
          <Grid item xs={12} sx={{ m: 0, p: 0 }}>
            <Typography
              sx={{
                m: 0,
                p: 0,
                pl: 1,
                letterSpacing: 1,
                textAlign: 'left',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                fontWeight: 'bold',
                fontSize: 18,
              }}
            >
              {company?.name}
            </Typography>
          </Grid>
          <Grid item xs={12} sx={{ m: 0, p: 0 }}>
            <Typography
              sx={{
                m: 0,
                p: 0,
                pl: 1,
                letterSpacing: 1,
                textAlign: 'left',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                fontWeight: 'bold',
                fontSize: 16,
                color: 'secondary.text',
              }}
            >
              {t('order.ordered.organizationNumber', {
                organizationNumber:
                  company?.organizationNumber || 'No org number',
              })}
            </Typography>
          </Grid>
          <Grid item xs={12} sx={{ m: 0, p: 0 }}>
            <Typography
              sx={{
                m: 0,
                p: 0,
                pl: 1,
                letterSpacing: 1,
                textAlign: 'left',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                fontWeight: 'normal',
                fontSize: 16,
              }}
            >
              {company?.email || ''}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
